import { Button, Icons } from '@sede-enterprise/shell-ds-react-framework';

type Props = {
  focused: boolean;
  onToggle: () => void;
};

const TableFocusToggle = ({ focused, onToggle }: Props) => {
  const label = focused ? 'Exit table focus mode' : 'Expand table';
  const FocusIcon = focused ? Icons.FullScreenExit : Icons.FullScreen;
  return (
    <div className='table-focus-toolbar'>
      <Button
        size='small'
        variant='outlined'
        iconOnly
        aria-label={label}
        title={label}
        aria-pressed={focused}
        onClick={onToggle}
        icon={<FocusIcon width={20} height={20} aria-hidden='true' />}
      />
    </div>
  );
};

export default TableFocusToggle;
